import { createFileRoute } from '@tanstack/react-router'
import WishlistScreen from '../../screens/Wishlist'

export const Route = createFileRoute('/c/wishlist')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div><WishlistScreen /></div>
}
